<template>
    <div class="root">
      <div class="top">
        <!--<div class="circle">
          <div class="text-1">已使用流量</div>
          <div class="text-2">{{p}}<span style="font-size: .64rem;margin-left: -.2rem">%</span></div>
          <div class="text-3">剩余流量：{{remainUsage}}G</div>
        </div>-->
        <van-circle
          v-model="p"
          :rate="30"
          :speed="100"
          color="#ff8e97"
          size="6.3rem"
          class="circle"
          :stroke-width="60"
        >
          <div style="padding-top: 1rem">
            <div class="text-1">已使用流量</div>
            <div class="text-2">{{p}}<span style="font-size: .64rem;">%</span></div>
            <div class="text-3">剩余流量：{{remainUsage}}G</div>
          </div>
        </van-circle>
      </div>
      <div class="bottom">
        <div>设备卡号：{{iccid}}</div>
        <div>当前套餐：
          <span class="sucess" v-if="packageName">{{packageName}}</span>
          <span class="error" v-else>当前没有套餐</span>
        </div>
        <div>运营状态：
          <span class="error" v-if="simStatusName.indexOf('停') !== -1 || simStatusName.indexOf('管') !== -1">{{simStatusName}}</span>
          <span class="sucess" v-else>{{simStatusName}}</span>
        </div>
      </div>
      <div class="btn" @click="$router.push({name:'recharge',query:{iccid:iccid}})">充值</div>
    </div>
</template>

<script>
    export default {
        name: "usage",
      data() {
        return {
          iccid:'',
          simStatusName:'',
          simAuthStatus:'',
          totalUsage:0,
          remainUsage:0,
          usedUsage:'',
          packageName:''
        }
      },
      computed:{
          p:{
            get(v){
              if(this.totalUsage > 0) {
                let value =  parseFloat(((this.usedUsage / this.totalUsage)*100).toFixed(2))
                console.log(value)
                return value
              }else{
                return 0
              }
            },
            set(v) { }
          }
      },
      methods:{
        queryCardStatus() {
          this.$toast.loading({message: '加载中', duration: 0});
          this.fetchData('/card/status', {iccid: this.iccid}, (res) => {
            this.$toast.clear()
            if (res.code) {
              this.simStatusName = res.data.simStatusName;
              this.simAuthStatus = res.data.simAuthStatus;
              this.totalUsage = res.data.total;
              this.remainUsage = res.data.remain
              this.usedUsage = res.data.used
            } else {
              this.$toast.fail(res.msg)
            }
          })
        },
        getNowPackage(){
          this.fetchData('/package/getNowPackage',{iccid:this.iccid},res=>{
            if(res.code) {
              this.packageName = res.data
            }
          })
        }
      },
      created() {
          this.iccid = this.$route.query.iccid
          this.queryCardStatus()
        this.getNowPackage()
      }
    }
</script>

<style scoped lang="scss">
  .root{
    .btn{
      width: 2.8rem;
      text-align: center;
      height: .8rem;
      line-height: .8rem;
      color: #fff;
      font-size: .34rem;
      font-weight: bold;
      letter-spacing: .14rem;
      text-indent: .14rem;
      background: #F05864FF;
      border-radius: .2rem;
      margin: 1rem auto 0;
    }
    .bottom{
      background: #fbdde0;
      div{
        font-size: .3rem;
        width: 6.3rem;
        padding: 0 .6rem;
        margin: 0 auto;
        height: .9rem;
        line-height: .9rem;
        border-bottom: 1px solid #aaa;
        .sucess{
          color: #0b8ed4;
        }
        .error{
          color: #F05864FF;
        }
      }
    }
    .top{
      background: linear-gradient(180deg, #ff8e97,#f05965);
      padding: .4rem 0;
      .circle{
        margin: 0 auto;
        display: block;
        font-size: 0;
        text-align: center;
        color: #fff;
        position: relative;
        .text-1{
          /*margin-top: 1rem;*/
          font-size: .42rem;
          letter-spacing: .1rem;
          text-indent: .1rem;
          position: inherit;
        }
        .text-2{
          font-weight: bold;
          font-size: 1.4rem;
          margin-top: .8rem;
        }
        .text-3{
          margin-top: 0;
          font-size: .32rem;
        }
      }
    }
    height: inherit;
    font-size: 0;
    overflow-y: scroll;
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/usage.vue